import {Component, Input, OnInit} from '@angular/core';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {GeneralService} from '../../services/general.service';
import {LokijsService} from '../../services/database/lokijs.service';
import {ContactModel} from '../../models/contact.model';
import {SiteModel} from '../../models/site.model';
import {ConfigurationService} from '../../services/configuration.service';
import {ValidateWsJobService} from '../../services/workshopServices/validate-ws-job.service';
import {PersistDocumentService} from '../../services/persist-document.service';
import {CustomerModel} from '../../models/customer.model';
import {ConfigurationModel} from '../../models/configuration.model';
import {CollectionsNames} from '../../definitions/collections-names';
import {StateManagerService} from '../../services/state-manager.service';
import { NewDocumentService } from 'src/app/services/new-document.service';
import { DocumentTypes } from 'src/app/definitions/document-types';
import { DetaillineDTOModel } from 'src/app/models/detaillineDTO.model';
import { BinLocationModel } from 'src/app/models/bin-location.model';

@Component({
    selector: 'app-customer-service-job-details',
    templateUrl: './customer-service-job-details.page.html',
    styleUrls: ['./customer-service-job-details.page.scss'],
})
export class CustomerServiceJobDetailsPage implements OnInit {

    @Input() document: DocumentModel;
    config: ConfigurationModel;
    documentTemp: DocumentModel;
    mobileConfiguration: any;
    meterReadingTypes = [];
    //transportItem: DetaillineDTOModel = new DetaillineDTOModel();
    loading: any;
    transportChoices: string[] = ['Van Collect','Van Deliver'];


    constructor(private modalController: ModalController,
                private generalServices: GeneralService,
                private loki: LokijsService,
                private loadingController: LoadingController,
                private alertController: AlertController,
                private configurationService: ConfigurationService,
                private docTypes: DocumentTypes,
                private newDocumentService: NewDocumentService,
                private validateWsJob: ValidateWsJobService,
                private persistDocumentService: PersistDocumentService,
                private configService: ConfigurationService,
                private collNames: CollectionsNames,
                private stateManager: StateManagerService) {
    }

    async ngOnInit() {
        if (!this.document.serviceJob || this.document.serviceJob === null ) {
            this.document = this.newDocumentService.buildServiceJobDocumentBean( this.newDocumentService.buildNewServiceJobObj() );
            this.document.documentType = this.docTypes.CUSTOMERSERVICE;
        }
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
        this.config = this.stateManager.getCollection(this.collNames.CONFIGURATION);
        this.mobileConfiguration = this.stateManager.getCollection(this.collNames.MOBILECONFIGURATION);
        this.meterReadingTypes = this.stateManager.getCollection(this.collNames.METERTYPE);
        this.handleAssigningTransportItem();
        this.handleAssigningEngineerSignature();
    }

    handleAssigningTransportItem(){
        /*const transportItems = this.document.detailLines.filter(item => {
            return item.transportProductType;
        });
        if( transportItems.length > 0){
            this.transportItem = transportItems[0];
        }*/

        if( !this.documentTemp.serviceJob.transportChoices || this.documentTemp.serviceJob.transportChoices.length === 0  ){
            this.transportChoices[0] = "Van Collect";
            this.transportChoices[1] = "Van Deliver";
            this.documentTemp.serviceJob.transportChoices = this.transportChoices;
        }else{
            this.transportChoices = this.documentTemp.serviceJob.transportChoices;
        }
    }

    async ionViewWillEnter() {
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.contact = new ContactModel();
        this.documentTemp.signatureContact = new ContactModel();
        this.documentTemp.site = new SiteModel();
        this.documentTemp.signature = null;
    }

    listenTransportItem(event){
        //this.transportItem = event;
    }

    /*async saveServiceJob() {
        this.documentTemp.serviceJob.isChargeable = true; // customer repair jobs alway start as chargeable
        console.log( this.documentTemp.serviceJob);
        //return;
        // TODO: Refacto this method. Too much code repetition

        if (!this.validateWsJob.validateServiceJob(this.documentTemp)) {
            console.log('Invalid Job');
            return;
        } else {







            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            this.populateJobServiceParams(this.document).then(() => {
                this.document.serviceJob.site = this.document.site;
                this.document.serviceJob.binLocation = new BinLocationModel();
                this.document.serviceJob.jobTypeId = this.document.serviceJob.jobTypeId; 
                this.handleAddingTransportItem();
                this.persistDocumentService.persistDocument(this.document);
                this.modalController.dismiss(this.document);
            });
        }
    }*/




    async saveServiceJob(){
        if (!this.validateWsJob.validateServiceJob(this.documentTemp)) {
            console.log('Invalid Job');
            return;
        }else{


        
        if (this.documentTemp.serviceJob.jobStatus !== 7) {
            const alert = await this.alertController.create({
                message: 'Do you want to complete the Job?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: async () => {
                            this.document = JSON.parse(JSON.stringify(this.documentTemp));
                            this.document.serviceJob.completedJob = false;
                            this.populateJobServiceParams(this.document).then(async () => {
                                this.document.serviceJob.site = this.document.site;
                                this.document.serviceJob.binLocation = new BinLocationModel();
                                this.document.serviceJob.jobTypeId = this.document.serviceJob.jobTypeId; 
                                this.handleAddingTransportItem();
                                this.persistDocumentService.persistDocument(this.document);
                                this.modalController.dismiss(this.document);
                            });
                        }
                    }, {
                        text: 'Yes',
                        handler: async () => {
                            this.document = JSON.parse(JSON.stringify(this.documentTemp));
                            if (!this.validateWsJob.handleSignature(this.documentTemp)) {
                                this.generalServices.createToast('Engineer signature needed to complete the job');
                            } else if (!this.validateWsJob.checkMandatoryReadings(this.documentTemp.serviceJob)) {
                                // It'll alert from the method if it fails
                            } else if(  !this.tasksValid( this.documentTemp ) ){
                                this.alertInvalidReasons('Cannot complete a job with failing tasks');
                            } else {
                                this.document.serviceJob.completedJob = true;
                                this.document.serviceJob.jobStatus = 7;
                                this.populateJobServiceParams(this.document).then(async () => {
                                    this.document.serviceJob.site = this.document.site;
                                    this.document.serviceJob.binLocation = new BinLocationModel();
                                    this.document.serviceJob.jobTypeId = this.document.serviceJob.jobTypeId; 
                                    this.handleAddingTransportItem();
                                    this.persistDocumentService.persistDocument(this.document);
                                    this.modalController.dismiss(this.document);
                                });
                            }
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            this.populateJobServiceParams(this.document).then(async () => {

                this.document.serviceJob.site = this.document.site;
                this.document.serviceJob.binLocation = new BinLocationModel();
                this.document.serviceJob.jobTypeId = this.document.serviceJob.jobTypeId; 
                this.handleAddingTransportItem();
                this.persistDocumentService.persistDocument(this.document);
                this.loading.dismiss();
                this.modalController.dismiss(this.document);


                await this.persistDocumentService.persistDocument(this.document);
                this.modalController.dismiss(this.document);
            });
        }

        }
    }

    tasksValid(doc: DocumentModel ){
        var allTasksDone = true;

        if( !this.mobileConfiguration.mobilehireServiceJobDontCompleteIfTasksFail ){
            return allTasksDone;
        }

        for( const task of doc.serviceJob.tasks ){
            if( task.option === 0  ){
                allTasksDone = false;
            }
        }

        return allTasksDone;
    }

    async alertInvalidReasons(msg: string) {
        const alert = await this.alertController.create({
            header: 'Requirements Missing',
            backdropDismiss: false,
            message: msg,
            buttons: [
                {
                    text: 'Ok',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }
            ]
        });
        await alert.present();
    }

    async loadingSpinner() {
        await this.loadingController.create({
            message: 'Saving ...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
    }



    handleAddingTransportItem(){
        // remove the current transport item from detaillines
        /*this.document.detailLines = this.document.detailLines.filter(item => {
            return !item.transportProductType;
        });*/

        // add the transportItem detailline that was set in the component delivery-back-choice
        //this.document.detailLines.push(this.transportItem);

        console.log('Adding TrasportItem');
        //console.log(this.transportItem);
    }

    async handleAssigningEngineerSignature(){

        if( !this.mobileConfiguration.mobilehireUseEngineerSignatureStoring ){
            return;
        }
        console.log("handleAssigningEngineerSignature");
        const engineer = await this.loki.getCollection('engineer')
        .chain().find({id: this.config.selectedEngineer}).data()[0];

        if( engineer.signature_base64 && 
            engineer.signature_base64 !='' && 
            ( !this.documentTemp.engineerSignature ) ){
            this.documentTemp.engineerSignature = engineer.signature_base64;
        }
    }

    async populateJobServiceParams(doc: DocumentModel) {
        const engineer = await this.loki.getCollection('engineer')
            .chain().find({id: this.config.selectedEngineer}).data()[0];
        const operator = await this.loki.getCollection('operator')
            .chain().find({cod: this.config.selectedOperator}).data()[0];
        console.log(engineer, operator);
        if (doc.isNewDoc) {
            delete doc.serviceJob.isNewDoc;
        }
        if (this.checkMalformedCustomer(doc.customer)) {
            doc.customer = new CustomerModel();
        }

        console.log(doc.serviceJob.completedJob);
        if (doc.serviceJob.completedJob && !doc.serviceJob.complete) {
            doc.serviceJob.jobStatus = 7; // 7 is for completed job
            doc.serviceJob.complete = new Date().toISOString();
        }
        doc.serviceJob.engineer = engineer;
        doc.serviceJob.operator = operator;
        this.setDepot(doc);

        console.log(doc);
    }

    private checkMalformedCustomer(customer: CustomerModel) {
        if (!customer) {
            return true;
        }
        return !customer.id || !customer.cod;
    }

    setDepot(doc) {
        doc.serviceJob.depot = this.loki.getCollection('depot')
            .chain().find({cod: this.configService.getConfiguration().selectedDepot}).data()[0];
    }

    cancelService() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            this.confirmCancel();
        } else {
            this.modalController.dismiss();
        }
    }

    async confirmCancel() {
        const alert = await this.alertController.create({
            message: 'Do you want to cancel the Job alterations?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.modalController.dismiss();
                    }
                }
            ]
        });
        await alert.present();
    }
}
